export default ({ request }) => ({

  sampleListApi (data = {}) {
    return request({
      url: '/digitalCenter/project/infoSample/getProjectInfoSample',
      method: 'post',
      data
    })
  },
  sampleInitApi (data = {}) {
    return request({
      url: '/digitalCenter/project/infoSample/initProjectInfoSample',
      method: 'post',
      data
    })
  },
  sampleUpdateApi (data = {}) {
    return request({
      url: '/digitalCenter/project/infoSample/updateProjectInfoSample',
      method: 'post',
      data
    })
  }
})
